var _circle, _rect, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTrashSm = function SvgTrashSm(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F2F4F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.00056H16.5C16.7761 9.00056 17 9.2244 17 9.50053C17 9.77665 16.7761 10.0005 16.5 10.0005H16V15.5001C16 16.3285 15.3284 17 14.5 17H9.5C8.67157 17 8 16.3285 8 15.5001V10.0005H7.5C7.22386 10.0005 7 9.77665 7 9.50053C7 9.2244 7.22386 9.00056 7.5 9.00056H10V8.16562C10.0244 7.49922 10.5835 6.97821 11.25 7.0007H12.75C13.4165 6.97821 13.9756 7.49922 14 8.16562V9.00056ZM10.5 14.5004C10.7761 14.5004 11 14.2766 11 14.0005V12.0006C11 11.7245 10.7761 11.5007 10.5 11.5007C10.2239 11.5007 10 11.7245 10 12.0006V14.0005C10 14.2766 10.2239 14.5004 10.5 14.5004ZM11 8.16564C11 8.08565 11.105 8.00065 11.25 8.00065H12.75C12.895 8.00065 13 8.08565 13 8.16564V9.00058H11V8.16564ZM13.5 14.5004C13.7761 14.5004 14 14.2766 14 14.0005V12.0006C14 11.7245 13.7761 11.5007 13.5 11.5007C13.2239 11.5007 13 11.7245 13 12.0006V14.0005C13 14.2766 13.2239 14.5004 13.5 14.5004Z",
    fill: "#E02020"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashSm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash_sm.9994a6b4.svg";
export { ForwardRef as ReactComponent };